module.exports = __webpack_public_path__ + "static/media/heavy_pound12.01bfd8f5.jpg";